import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ZendeskChat from '../../chat/ZendeskChat';

const SupportFooter = () => {
  const handleMinMenuToggleClick = e => {
    e.stopPropagation();
    if (document.body.classList.contains('nav-function-minify')) {
      document.body.classList.remove('nav-function-minify');
      document.body.classList.remove('mod-hide-info-card');
    } else {
      document.body.classList.add('nav-function-minify');
      document.body.classList.add('mod-hide-info-card');
    }
  };

  return (
    <div className="nav-footer shadow-top">
      <a
        className="hidden-md-down"
        data-class="nav-function-minify"
        onClick={handleMinMenuToggleClick}
      >
        <i className="fas fa-angle-right fa-lg" />
        <i className="fas fa-angle-right fa-lg" />
      </a>
      <ul className="list-table m-auto nav-footer-buttons">
        <li>
          <OverlayTrigger
            placement="top"
            overlay={(
              <Tooltip id="tooltip-p9-website" style={{ margin: 0 }}>
                Pillar 9™ Website
                <br />
                www.pillarnine.com
              </Tooltip>
            )}
          >
            <a
              href="//www.pillarnine.com"
              aria-label="Pillar 9™ Website www.pillarnine.com"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fas fa-globe fa-lg" />
            </a>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger
            placement="top"
            overlay={(
              <Tooltip id="tooltip-p9-email" style={{ margin: 0 }}>
                Pillar 9™ Support Centre
                <br />
                Email: support@pillarnine.comc
              </Tooltip>
            )}
          >
            <a
              href="mailto:helpdesk@pillarnine.com"
              aria-label="Pillar 9™ Support Centre Email: support@pillarnine.com"
            >
              <i className="fas fa-envelope fa-lg" />
            </a>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger
            placement="top"
            overlay={(
              <Tooltip id="tooltip-p9-phone" style={{ margin: 0 }}>
                Pillar 9™ Support Centre
                <br />
                Phone: 587-430-2991
              </Tooltip>
            )}
          >
            <a
              href="tel:866-377-8217"
              aria-label="Pillar 9™ Support Centre Phone: 587-430-2991"
            >
              <i className="fas fa-phone fa-lg" />
            </a>
          </OverlayTrigger>
        </li>
        <li>
          <ZendeskChat />
        </li>
      </ul>
    </div>
  );
};

export default SupportFooter;
